module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isshow),
      expression: "isshow"
    }]
  }, [_c('div', {
    staticClass: "m-popup-layer"
  }, [_c('table', {
    staticClass: "m-popup-table"
  }, [_c('tbody', [_c('tr', [_c('td', [_c('div', {
    staticClass: "tip-content",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
      }
    }
  }, [_c('p', {
    staticClass: "tip-title"
  }, [_vm._v("提示信息")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.errorText))]), _vm._v(" "), _c('p', {
    staticClass: "tip-btn"
  }, [_c('a', {
    on: {
      "click": _vm.setVshow
    }
  }, [_vm._v("我知道了")])])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54b520f0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/tip-dialog.vue
// module id = 132
// module chunks = 2 4 6